var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuUtente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.468,
    height: 23.006,
    viewBox: "0 0 24.468 23.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1033",
    "data-name": "Raggruppa 1033",
    transform: "translate(-1673.927 -5093.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7028",
    "data-name": "Tracciato 7028",
    d: "M6.656,11.034a5.518,5.518,0,1,1,5.512-5.518,5.527,5.527,0,0,1-5.512,5.518m0-9.807a4.29,4.29,0,1,0,4.29,4.29,4.3,4.3,0,0,0-4.29-4.29",
    transform: "translate(1679.506 5094.383)",
    fill: "#555",
    stroke: "#555",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7029",
    "data-name": "Tracciato 7029",
    d: "M11.733,3.6a10.944,10.944,0,0,1,10.468,7.8h1.266A12.138,12.138,0,0,0,0,11.408H1.265A10.944,10.944,0,0,1,11.733,3.6",
    transform: "translate(1674.428 5104.979)",
    fill: "#555",
    stroke: "#555",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUtente);
export default __webpack_public_path__ + "static/media/menu-utente.86678fc7f7140a68c4c313a8c7722579.svg";
export { ForwardRef as ReactComponent };